// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HKGY","placeholdersHeader":"styles_placeholdersHeader__2dqPY","editorStyle":"styles_editorStyle__ivB77","placeholdersBox":"styles_placeholdersBox__WGnUU"};